var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.6673 13.0163V26.983C36.6673 31.6663 34.5173 34.883 30.734 36.0996C29.634 36.483 28.3673 36.6663 26.984 36.6663H13.0173C11.634 36.6663 10.3673 36.483 9.26731 36.0996C5.48398 34.883 3.33398 31.6663 3.33398 26.983V13.0163C3.33398 6.94967 6.95065 3.33301 13.0173 3.33301H26.984C33.0507 3.33301 36.6673 6.94967 36.6673 13.0163Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7343 36.0999C29.6343 36.4832 28.3676 36.6666 26.9843 36.6666H13.0176C11.6342 36.6666 10.3676 36.4832 9.26758 36.0999C9.85091 31.6999 14.4509 28.2832 20.0009 28.2832C25.5509 28.2832 30.1509 31.6999 30.7343 36.0999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9665 19.2997C25.9665 22.5997 23.2999 25.283 19.9999 25.283C16.6999 25.283 14.0332 22.5997 14.0332 19.2997C14.0332 15.9997 16.6999 13.333 19.9999 13.333C23.2999 13.333 25.9665 15.9997 25.9665 19.2997Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCount);
export default __webpack_public_path__ + "static/media/user-count.b672a4406405e44d90546f5034d60209.svg";
export { ForwardRef as ReactComponent };